import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const RowItem = styled.div`
  padding: 18px 0 8px 0;
  border-bottom: solid 1px ${Variables.colors.complementary_300};
  .cost-info-row,
  .budget-info-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .label {
      display: flex;
      align-items: center;
      padding-left: 24px;
    }
    .value {
      line-height: 1.7;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .unit {
      margin-right: 4px;
      font-size: ${Variables.font_sizes.small};
      font-weight: ${Variables.font_weight.light};
      color: ${Variables.colors.complementary_500};
    }
  }
  .cost-info-row {
    margin-bottom: 10px;
    .label {
      font-size: ${Variables.font_sizes.medium};
      color: ${Variables.colors.complementary_700};
    }
    .value {
      font-size: ${Variables.font_sizes.x1_medium};
      color: ${Variables.colors.complementary_800};
    }
  }
  .budget-info-row {
    margin-bottom: 4px;
    .label {
      font-size: ${Variables.font_sizes.medium};
      color: ${Variables.colors.complementary_600};
      font-weight: ${Variables.font_weight.light};
      line-height: 1.6;
    }
    .value {
      font-size: ${Variables.font_sizes.x_small};
      color: ${Variables.colors.complementary_700};
    }
  }
`;
